import { useState, useEffect, useCallback, useRef } from "react";
import { MoveLeft } from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Dropdown,
  Button,
  Spinner,
  ToastContainer,
  Toast,
  Carousel,
} from "react-bootstrap";
import {
  getTripsViewApi,
  getActualWorkflowApi,
  getEstimateWorkflowApi,
  deleteTripsApi,
  getStopsListApi,
  getAllocationHistoryApi,
  getStopProductListApi,
  getSkippedMilestoneApi,
  updateDriverAPI,
  getProductDetailsApi,
  productConfirmationApi,
  paymentUpdateApi,
  getUpdateMilestoneApi,
  getNextMilestoneApi,
  getUpdateSkippedMilestoneApi,
} from "./trips-api";
import locationIcon from "../../assets/svg/location_ic.svg";
import moreIcon from "../../assets/svg/more_ic.svg";

import DeleteModal from "../common/deleteModel";
import dateIc from "../../assets/svg/date_ic.svg";

import dollerIc from "../../assets/svg/doller_ic.svg";
import workflowTick from "../../assets/svg/workflow-tick.svg";
import activeStop from "../../assets/svg/active-location.svg";
import activeWorkflow from "../../assets/svg/active-workflow.svg";
import workflowIcon from "../../assets/svg/workflow.svg";
import tripIcon from "../../assets/svg/trip_view_ic.svg";
import milestoneIcon from "../../assets/svg/flag_ic.svg";
import distanceIcon from "../../assets/png/estimated_km_so.png";
import timestampIcon from "../../assets/svg/time_ic.svg";
import truckIcon from "../../assets/svg/truck_ic.svg";
import redPinIcon from "../../assets/svg/location_pin_red.svg";
import whitePinIcon from "../../assets/svg/location_pin_white.svg";
import productIcon from "../../assets/svg/products_ic.svg";
import arrowDownIcon from "../../assets/svg/down_arrow_blue.svg";

import totalAmtIc from "../../assets/svg/total_amount.svg";
import totalKMIc from "../../assets/svg/total_km.svg";
import totalVolumeIc from "../../assets/svg/total_volume.svg";
import totalPackageIc from "../../assets/svg/total_package.svg";
import totalWeightIc from "../../assets/svg/total_weight.svg";
import personIc from "../../assets/svg/person_ic.svg";
import Sidebar from "../common/Sidebar";
import { Navbar } from "../common/Navbar";
import customerIcon from "../../assets/svg/customer_active_ic.svg";
import activeHistory from "../../assets/svg/history_active_ic.svg";
import historyIcon from "../../assets/svg/history_ic.svg";
import { Modal } from "react-bootstrap";
import stopPinImg from "../../assets/png/planned-pin.png";
import DriverAllocationModal from "./DriverAllocationModal";
import MilestoneUpdateModal from "./MilestoneUpdateModal";
import DeliveredModal from "./DeliveredModal";
import PaymentModal from "./PaymentModal";
import { useGlobal } from "../../GlobalContext";

import polyline from "@mapbox/polyline";
import {
  MapContainer,
  TileLayer,
  Marker,
  useMapEvents,
  Popup,
  Polyline,
} from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import MarkerClusterGroup from "react-leaflet-markercluster";
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

const LocationPicker = ({ setPosition }) => {
  useMapEvents({
    click(e) {
      setPosition(e.latlng);
    },
  });
  return null;
};

export const TripsView = () => {
  const { rolePermissionList, userType } = useGlobal();
  const location = useLocation();
  const navigate = useNavigate();
  const { id } = location.state || {};
  const [viewStopDetails, setViewStopDetails] = useState({});

  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(null);
  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);

  const [isLoading, setIsLoading] = useState(false);
  const [selectedTab, setSelectedTab] = useState("trips");
  const [selectedContactTab, setSelectedContactTab] = useState("Driver");
  const [actualWorkflow, setActualWorkflow] = useState([]);
  const [estimateWorkflow, setEstimateWorkflow] = useState([]);
  const [allocationHistory, setAllocationHistory] = useState([]);
  const [stopsList, setStopsList] = useState([]);
  const [driverList, setDriverList] = useState([]);
  const [coDriverList, setCoDriverList] = useState([]);
  const [deliveryPersonList, setDeliveryPersonList] = useState([]);
  const [productList, setProductList] = useState([]);
  const [selectedStopIndex, setSelectedStopIndex] = useState(-1);
  const [isProductLoading, setIsProductLoading] = useState(false);

  const [showMap, setShowMap] = useState(false);
  const [mapPosition, setMapPosition] = useState(null);

  const [showAttachmentModal, setShowAttachmentModal] = useState(false);
  const [attachmentUrl, setAttachmentUrl] = useState("");
  const [attachmentUrls, setAttachmentUrls] = useState([]);

  const [stopPinLocation, setStopPinLocation] = useState([]);
  const [stopPolyCoords, setStopPolyCoords] = useState([]);
  const [roadRouteCoords, setRoadRouteCoords] = useState([]);
  const [selectedStop, setSelectedStop] = useState(-1);

  useEffect(() => {
    if (id != null) {
      getTripsView(id);
      getStopsList(id);
      getActualWorkflow(id);
      getEstimateWorkflow(id);
      getAllocationHistory(id);
    }
  }, [id]);

  function checkPermission(permission) {
    return rolePermissionList.findIndex(
      (element) =>
        element["name"] === "Trips" &&
        element["menu_permission"] === true &&
        element[permission] === true
    ) > -1
      ? true
      : false;
  }

  useEffect(() => {
    if (selectedStopIndex !== -1) {
      getProductList(stopsList[selectedStopIndex].stop_id);
    }
  }, [selectedStopIndex]);

  useEffect(() => {
    if (mapPosition != null) {
      setShowMap(true);
    }
  }, [mapPosition]);

  // Fetch road-based route when stops change
  useEffect(() => {
    const fetchRoadRoute = async () => {
      if (stopPolyCoords.length < 2) {
        setRoadRouteCoords([]);
        return;
      }

      try {
        // Create coordinates string for OSRM API
        const coords = stopPolyCoords
          .map((coord) => `${coord[1]},${coord[0]}`)
          .join(";");

        // Use OSRM demo server for routing
        const response = await fetch(
          `https://router.project-osrm.org/route/v1/driving/${coords}?overview=full&geometries=polyline`
        );
        const data = await response.json();

        if (data.code === "Ok" && data.routes && data.routes[0]) {
          // Decode polyline to get route coordinates
          const route = data.routes[0];
          const decodedCoords = polyline.decode(route.geometry);
          setRoadRouteCoords(decodedCoords);
        } else {
          console.warn("No route found, using direct lines");
          setRoadRouteCoords(stopPolyCoords);
        }
      } catch (error) {
        console.error("Error fetching road route:", error);
        // Fallback to direct lines if routing fails
        setRoadRouteCoords(stopPolyCoords);
      }
    };

    fetchRoadRoute();
  }, [stopPolyCoords]);

  const getTripsView = async (id) => {
    try {
      const response = await getTripsViewApi(id);

      if (response.data.success === true) {
        setViewStopDetails(response.data.trip ?? {});
        setDriverList(response.data.driver ?? []);
        setCoDriverList(response.data.co_driver ?? []);
        setDeliveryPersonList(response.data.delivery_person ?? []);
      }
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const getStopsList = async (id) => {
    try {
      const response = await getStopsListApi(id);

      if (response.data.success === true) {
        setStopsList(response.data.stops ?? []);
        setStopPinLocation(
          response.data.stops?.filter(
            (marker) =>
              marker["to_latitude"] != null &&
              marker["to_longitude"] != null &&
              marker["to_latitude"] !== "" &&
              marker["to_longitude"] !== ""
          )
        );

        let polylineList = [];
        response.data.stops?.forEach((coords, index2) => {
          polylineList.push(
            [coords.to_latitude, coords.to_longitude].map(Number)
          );
        });
        setStopPolyCoords(polylineList);
      }
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const getActualWorkflow = async (id) => {
    try {
      const response = await getActualWorkflowApi(id);

      if (response.data.success === true) {
        setActualWorkflow(response.data.trip_history ?? []);
      }
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const getEstimateWorkflow = async (id) => {
    try {
      const response = await getEstimateWorkflowApi(id);

      if (response.data.success === true) {
        setEstimateWorkflow(response.data.est_workflow ?? []);
      }
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const getAllocationHistory = async (id) => {
    try {
      const response = await getAllocationHistoryApi(id);

      if (response.data.success === true) {
        setAllocationHistory(response.data.history ?? []);
      }
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const getProductList = async (stopId) => {
    setIsProductLoading(true);
    try {
      const response = await getStopProductListApi(stopId);

      if (response.data.success === true) {
        setProductList(response.data.products ?? []);
      }
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
      setIsProductLoading(false);
    }
  };
  const [deleteId, setDeleteId] = useState(null);
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  useEffect(() => {
    if (deleteId !== null) {
      setIsOpenDelete(true);
    }
  }, [deleteId]);
  const deleteVendor = async () => {
    // setIsLoading(true);
    try {
      const response = await deleteTripsApi(deleteId);
      console.log("response....", response);
      if (response.data.success === true) {
        navigate(-1);
      }
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
      setIsLoading(false);
    }
  };

  const createCustomMarker = (text) =>
    L.divIcon({
      className: "custom-icon",
      html: `
              <div style="position: relative; display: inline-block;">
                <!-- Your image from assets -->
                <img src="${stopPinImg}" style="width:40px;height:40px;" />
                
                <!-- Text overlay -->
                <span style="
                  position: absolute;
                  top: 50%;
                  left: 50%;
                  transform: translate(-50%, -50%);
                  color: white;
                  font-size: 14px;
                  font-weight: bold;
                ">
                  ${text}
                </span>
              </div>
            `,
      iconSize: [40, 40], // size of whole div
      iconAnchor: [20, 40], // bottom center
      popupAnchor: [0, -40],
    });

  const [showMilestoneModal, setShowMilestoneModal] = useState(false);
  const [isSkippedMilestone, setIsSkippedMilestone] = useState(false);
  const [milestoneDetails, setMilestoneDetails] = useState({});

  useEffect(() => {
    if (isSkippedMilestone === true) {
      setShowMilestoneModal(true);
    }
  }, [isSkippedMilestone]);

  const getMilestoneDetails = async (id) => {
    setIsSkippedMilestone(false);
    try {
      const response = await getNextMilestoneApi(id);
      if (response.data.success === true) {
        setMilestoneDetails(response.data);
        setShowMilestoneModal(true);
      }
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
      setIsLoading(false);
    }

    // Refresh list or take action as needed
    // getTripsList();
  };

  const getSkippedMilestoneDetails = async (tripId, stopId) => {
    try {
      const response = await getSkippedMilestoneApi(tripId, stopId);
      if (response.data.success === true) {
        setMilestoneDetails(response.data);
        setIsSkippedMilestone(true);
      }
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
      setIsLoading(false);
    }

    // Refresh list or take action as needed
    // getTripsList();
  };

  const [errorMsgMilestone, setErrorMsgMilestone] = useState({
    status: "",
    comments: "",
    signature: "",
    attachments: "",
    latitude: "",
    longitude: "",
  });
  const [errorMsgAllocation, setErrorMsgAllocation] = useState({
    vehicle_id: "",
    users: "",
  });

  const [errorMsgPaymentUpdate, setErrorMsgPaymentUpdate] = useState({
    payment_method: "",
    amount: "",
    signature: "",
    attachments: "",
  });

  const handleMilestoneUpdate = async (payload) => {
    try {
      let response = null;
      if (isSkippedMilestone === false) {
        response = await getUpdateMilestoneApi(payload);
      } else {
        payload.trip_id = id;
        payload.stop_id = selectedStop;
        response = await getUpdateSkippedMilestoneApi(id, payload);
      }
      if (response.status === 400) {
        new Promise((resolve, reject) => {
          const validationTemp = {
            status: "",
            comments: "",
            signature: "",
            attachments: "",
            latitude: "",
            longitude: "",
          };
          Object.entries(response.data.error).forEach(([key, value]) => {
            console.log(`${key}: ${value}`);
            validationTemp[key] = value.length === 0 ? "" : value[0];
          });
          setErrorMsgMilestone(validationTemp);
        });
      } else if (response.data.success === true) {
        setIsSkippedMilestone(false);
        setShowMilestoneModal(false);
        if (response.data?.redirectPage === "production-confirmation") {
          getProductDetails(payload.stop_id);
        } else {
          setMilestoneDetails({});
          getTripsView(id);
          getActualWorkflow(id);
        }
      } else {
        new Promise((resolve, reject) => {
          const validationTemp = {
            status: "",
            comments: "",
            signature: "",
            attachments: "",
            latitude: "",
            longitude: "",
          };
          Object.entries(response.data.error).forEach(([key, value]) => {
            console.log(`${key}: ${value}`);
            validationTemp[key] = value.length === 0 ? "" : value[0];
          });
          setErrorMsgMilestone(validationTemp);
        });
      }
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
      setIsLoading(false);
    }
  };

  const [showDeliveredModal, setShowDeliveredModal] = useState(false);
  const [stopProduct, setStopProduct] = useState([]);
  const getProductDetails = async (stopId) => {
    try {
      const response = await getProductDetailsApi(stopId);
      if (response.data.success === true) {
        setStopProduct(
          response.data.products?.map((product) => ({
            ...product,
            duplicateprice: product.price,
            singleprice:
              (parseFloat(product.price) || 0) /
              (parseInt(product.quantity) || 1),
            returnqty: 0,
            dueqty: 0,
          }))
        );
        setShowDeliveredModal(true);
      }
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
      setIsLoading(false);
    }

    // Refresh list or take action as needed
    // getTripsList();
  };

  const handleDeliveryUpdate = async (payload) => {
    console.log("handleDeliveryUpdate called");
    console.log("milestoneDetails:", milestoneDetails);
    console.log("Received payload:", payload);

    try {
      payload.stop_id = milestoneDetails.stopId ?? 0;
      payload.trip_id = milestoneDetails?.trip?.id ?? 0;
      payload.milestone_id =
        milestoneDetails?.status.length > 0
          ? milestoneDetails?.status[0].milestone_id
          : 0;

      console.log("Final payload with IDs:", payload);

      // Validate required IDs
      if (
        payload.stop_id === 0 ||
        payload.trip_id === 0 ||
        payload.milestone_id === 0
      ) {
        console.error("Missing required IDs in payload:", {
          stop_id: payload.stop_id,
          trip_id: payload.trip_id,
          milestone_id: payload.milestone_id,
        });
        setSnackbarMessage(
          "Error: Missing required information. Please try updating the milestone first."
        );
        setSnackbarStatus(false);
        handleSnackbarShow();
        return;
      }

      const response = await productConfirmationApi(payload);
      console.log("Product confirmation response:", response);

      if (response.data.success === true) {
        if (response.data.redirectPage === "") {
          setShowDeliveredModal(false);
          getTripsView(id);
          getActualWorkflow(id);
        } else if (response.data.redirectPage === "payment") {
          setShowDeliveredModal(false);
          setShowPaymentModal(true);
        }
      } else {
        console.error("API returned success=false:", response.data);
        setSnackbarMessage(
          response.data.message || "Failed to update delivery information"
        );
        setSnackbarStatus(false);
        handleSnackbarShow();
      }
    } catch (err) {
      console.error("Error in handleDeliveryUpdate:", err);
      setSnackbarMessage(
        "An error occurred while updating delivery information"
      );
      setSnackbarStatus(false);
      handleSnackbarShow();
    } finally {
      setIsLoading(false);
    }
  };
  const handlePaymentUpdate = async (payload) => {
    try {
      payload.stop_id = milestoneDetails.stopId ?? 0;
      payload.trip_id = milestoneDetails?.trip?.id ?? 0;
      payload.milestone_id =
        milestoneDetails?.status.length > 0
          ? milestoneDetails?.status[0].milestone_id
          : 0;
      const response = await paymentUpdateApi(payload);
      if (response.status === 400) {
        new Promise((resolve, reject) => {
          const validationTemp = {
            payment_method: "",
            amount: "",
            signature: "",
            attachments: "",
          };
          Object.entries(response.data.error).forEach(([key, value]) => {
            console.log(`${key}: ${value}`);
            validationTemp[key] = value.length === 0 ? "" : value[0];
          });
          setErrorMsgPaymentUpdate(validationTemp);
        });
      } else if (response.data.success === true) {
        setShowPaymentModal(false);
        setSnackbarMessage(response.data.message);
        setSnackbarStatus(response.data.success);
        handleSnackbarShow();
        getTripsView(id);
        getActualWorkflow(id);
      } else {
        new Promise((resolve, reject) => {
          const validationTemp = {
            payment_method: "",
            amount: "",
            signature: "",
            attachments: "",
          };
          Object.entries(response.data.error).forEach(([key, value]) => {
            console.log(`${key}: ${value}`);
            validationTemp[key] = value.length === 0 ? "" : value[0];
          });
          setErrorMsgPaymentUpdate(validationTemp);
        });
      }
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
      setIsLoading(false);
    }
  };
  const [showPaymentModal, setShowPaymentModal] = useState(false);

  const [showDriverAllocationModal, setShowDriverAllocationModal] =
    useState(false);
  const handleDriverAllocate = async (payload) => {
    try {
      const response = await updateDriverAPI(payload);
      if (response.status === 400) {
        new Promise((resolve, reject) => {
          const validationTemp = { vehicle_id: "", users: "" };
          Object.entries(response.data.error).forEach(([key, value]) => {
            console.log(`${key}: ${value}`);
            validationTemp[key] = value.length === 0 ? "" : value[0];
          });
          setErrorMsgAllocation(validationTemp);
        });
      } else if (response.data.success === true) {
        setShowDriverAllocationModal(false);
        setSnackbarMessage("Driver assigned successfully");
        setSnackbarStatus(response.data.success);
        handleSnackbarShow();
        getTripsView(id);
        getAllocationHistory(id);
      } else {
        new Promise((resolve, reject) => {
          const validationTemp = { vehicle_id: "", users: "" };
          Object.entries(response.data.error).forEach(([key, value]) => {
            console.log(`${key}: ${value}`);
            validationTemp[key] = value.length === 0 ? "" : value[0];
          });
          setErrorMsgAllocation(validationTemp);
        });
      }
      console.log("Allocating driver payload:", payload);
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
      setIsLoading(false);
    }

    // Refresh list or take action as needed
    // getTripsList();
  };

  return (
    <>
      <DriverAllocationModal
        show={showDriverAllocationModal}
        onHide={() => setShowDriverAllocationModal(false)}
        tripId={id}
        onSubmit={handleDriverAllocate}
        errorMsgAllocation={errorMsgAllocation}
      />
      <MilestoneUpdateModal
        show={showMilestoneModal}
        onHide={() => {
          setMilestoneDetails({});
          setIsSkippedMilestone(false);
          setShowMilestoneModal(false);
        }}
        onSubmit={handleMilestoneUpdate}
        milestoneDetails={milestoneDetails}
        errorMsgMilestone={errorMsgMilestone}
        skippedUpdate={isSkippedMilestone}
      />
      <DeliveredModal
        show={showDeliveredModal}
        onHide={() => {
          setShowDeliveredModal(false);
        }}
        onSubmit={handleDeliveryUpdate}
        products={stopProduct}
      />
      <PaymentModal
        show={showPaymentModal}
        onHide={() => setShowPaymentModal(false)}
        onSubmit={handlePaymentUpdate}
        errorMsgPaymentUpdate={errorMsgPaymentUpdate}
      />
      <DeleteModal
        title={"trips"}
        isOpen={isOpenDelete}
        onClose={() => {
          setIsOpenDelete(false); // close modal
          setDeleteId(null); // reset selected ID
        }}
        onDelete={deleteVendor}
      />
      <div className="d-flex ">
        <Sidebar currentfile="Trips" />
        <div
          className="rounded-4 flex-grow-1  "
          style={{ width: "calc(100vw - 80px)" }}
        >
          <Navbar pageTitle="Trips" />
          <div
            className="p-2 scroll-hidden"
            style={{ background: "#F5F7FA", height: "calc(100vh - 56px)" }}
          >
            <div
              className="py-2 bg-white d-flex align-items-center justify-content-between"
              style={{
                borderTopLeftRadius: "16px",
                borderTopRightRadius: "16px",
              }}
            >
              <div className="d-flex align-items-center justify-content-start">
                <div
                  className="ms-2 d-flex align-items-center justify-content-center  rounded-5 bg-white"
                  style={{
                    width: "36px",
                    height: "36px",
                    border: "1px solid #EBEBEB",
                  }}
                >
                  <MoveLeft
                    className="cursor-pointer"
                    onClick={() => {
                      navigate(-1);
                    }}
                  />
                </div>

                <div
                  className="ms-3 d-flex align-items-center justify-content-center"
                  style={{
                    width: "64px",
                    height: "64px",
                    borderRadius: "16px",
                    background: "#DFE8FF",
                    color: "#3469E7",
                  }}
                >
                  <img src={tripIcon} alt="tripIcon" />
                </div>
                <div className="ms-2 d-flex flex-column align-items-start justify-content-center gap-1">
                  <div className="fs-20 fw-600 textFontColor">
                    {viewStopDetails.trip_id ?? ""}
                  </div>
                  <div className="d-flex align-items-center justify-content-start">
                    <img src={locationIcon} alt="location" />
                    <span
                      className="ms-2 fs-13 fw-400 "
                      style={{ color: "#A2A7AE" }}
                    >
                      {viewStopDetails.location ?? ""}
                    </span>
                    <div
                      className="mx-2"
                      style={{
                        width: "5px",
                        height: "5px",
                        borderRadius: "100px",
                        background: "#D9D9D9",
                      }}
                    ></div>
                    <div
                      className="d-flex align-items-center justify-content-center rounded-4 px-2 py-1"
                      style={{ background: "#EDF2FF", color: "#3469E7" }}
                    >
                      <span className="fs-12 fw-500">
                        #{viewStopDetails.customer_code ?? ""}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="d-flex align-items-center justify-content-start me-2">
                <Dropdown>
                  <Dropdown.Toggle
                    bsPrefix="custom-toggle"
                    variant="light"
                    id="dropdown-sort"
                    className="d-flex align-items-center justify-content-between backgroundLightOrange rounded-5"
                    style={{
                      padding: "10px 12px",
                    }}
                  >
                    <span className="d-flex align-items-center px-1 gap-2">
                      <span
                        className="backgroundYellow"
                        style={{
                          width: "10px",
                          height: "10px",
                          borderRadius: "3px",
                          display: "inline-block",
                        }}
                      ></span>

                      <span className="dropdown-text textcolor fs-13 fw-500">
                        {viewStopDetails.status ?? "-"}
                      </span>

                      {/* <span className="dropdown-toggle-arrow"></span> */}
                    </span>
                  </Dropdown.Toggle>
                </Dropdown>

                <div className="ms-2">
                  {(((checkPermission("edit_permission") ||
                    checkPermission("delete_permission")) &&
                    viewStopDetails.status === "Created") ||
                    viewStopDetails.status !== "Trip end") && (
                    <Dropdown>
                      <Dropdown.Toggle
                        bsPrefix="custom-toggle"
                        variant="light"
                        id="dropdown-sort"
                        className="d-flex align-items-center justify-content-between  rounded-5 bg-white"
                        style={{
                          width: "36px",
                          height: "36px",
                          border: "1px solid #EBEBEB",
                        }}
                      >
                        <span className="d-flex align-items-center px-1 gap-2">
                          <img src={moreIcon} alt="more" />
                        </span>
                      </Dropdown.Toggle>

                      <Dropdown.Menu
                        style={{
                          backgroundColor: "white",
                          borderRadius: "8px",
                          border: "1px solid #EBEBEB",
                          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                        }}
                      >
                        {viewStopDetails.status !== "Trip end" && (
                          <Dropdown.Item
                            className="fs-14 fw-500 textcolor"
                            onClick={() => {
                              getMilestoneDetails(id);
                            }}
                          >
                            Update Milestone
                          </Dropdown.Item>
                        )}

                        {viewStopDetails.status !== "Trip end" && (
                          <Dropdown.Item
                            className="fs-14 fw-500 textcolor"
                            onClick={() => {
                              setShowDriverAllocationModal(true);
                            }}
                          >
                            Allocate Driver
                          </Dropdown.Item>
                        )}

                        {checkPermission("edit_permission") &&
                          viewStopDetails.status === "Created" && (
                            <Dropdown.Item
                              className="fs-14 fw-500 textcolor"
                              onClick={() => {
                                navigate("/trips/create", {
                                  state: { id: id },
                                });
                              }}
                            >
                              Edit
                            </Dropdown.Item>
                          )}
                        {checkPermission("delete_permission") &&
                          viewStopDetails.status === "Created" && (
                            <Dropdown.Item
                              className="fs-14 fw-500 textcolor"
                              onClick={() => {
                                setDeleteId(id);
                              }}
                            >
                              Delete
                            </Dropdown.Item>
                          )}
                      </Dropdown.Menu>
                    </Dropdown>
                  )}
                </div>
              </div>
            </div>
            <div
              className="w-100 mb-1  d-flex align-items-center justify-content-start"
              style={{ background: "#EBF3FF" }}
            >
              <div
                className={`cursor-pointer d-flex align-items-center justify-content-center  px-2 fs-13  ${
                  selectedTab === "trips"
                    ? "fw-500 active-bottom-bar "
                    : " fw-400"
                } `}
                style={{
                  height: "40px",
                  minWidth: "110px",
                  color: selectedTab === "trips" ? "#3469E7" : "#5F5E5B",
                }}
                onClick={() => {
                  setSelectedTab("trips");
                }}
              >
                <img
                  src={selectedTab === "trips" ? activeStop : locationIcon}
                  alt="tab"
                  className="me-1"
                />{" "}
                Trip details
              </div>
              <div
                className={`cursor-pointer d-flex align-items-center justify-content-center  px-2 fs-13  ${
                  selectedTab === "workflow"
                    ? "fw-500 active-bottom-bar "
                    : " fw-400"
                } `}
                style={{
                  height: "40px",
                  minWidth: "110px",
                  color: selectedTab === "workflow" ? "#3469E7" : "#5F5E5B",
                }}
                onClick={() => {
                  setSelectedTab("workflow");
                }}
              >
                <img
                  src={
                    selectedTab === "workflow" ? activeWorkflow : workflowIcon
                  }
                  alt="tab"
                  className="me-1"
                />{" "}
                Workflow
              </div>

              <div
                className={`cursor-pointer d-flex align-items-center justify-content-center  px-2 fs-13  ${
                  selectedTab === "history"
                    ? "fw-500 active-bottom-bar "
                    : " fw-400"
                } `}
                style={{
                  height: "40px",
                  minWidth: "110px",
                  color: selectedTab === "history" ? "#3469E7" : "#5F5E5B",
                }}
                onClick={() => {
                  setSelectedTab("history");
                }}
              >
                <img
                  src={selectedTab === "history" ? activeHistory : historyIcon}
                  alt="tab"
                  className="me-1"
                />{" "}
                Allocation history
              </div>
            </div>
            {selectedTab === "trips" && (
              <>
                <div className="row d-flex align-items-stretch">
                  <div className="col-12 col-lg-6 mt-2">
                    <div className="bg-white rounded-4 p-3 d-flex flex-column align-items-start justify-content-start">
                      <div className="fs-16 fw-600 textFontColor">
                        Trip details
                      </div>

                      <div className="mt-3 d-flex align-items-center justify-content-start">
                        <div
                          style={{ width: "200px" }}
                          className="d-flex align-items-center justify-content-start"
                        >
                          <img src={milestoneIcon} alt="location" />
                          <span className="ms-2 fs-13 fw-500 cardTextGrey">
                            Milestone group
                          </span>
                        </div>
                        <div className="fs-13 fw-500 textFontColor">
                          {viewStopDetails.milestone ?? ""}
                        </div>
                      </div>

                      <div className="mt-3 d-flex align-items-center justify-content-start">
                        <div
                          style={{ width: "200px" }}
                          className="d-flex align-items-center justify-content-start"
                        >
                          <img src={dateIc} alt="date" />
                          <span className="ms-2 fs-13 fw-500 cardTextGrey">
                            Actual delivery date
                          </span>
                        </div>
                        <div className="fs-13 fw-500 textFontColor">
                          {viewStopDetails.actdeliverytime ?? ""}
                        </div>
                      </div>

                      <div className="mt-3 d-flex align-items-center justify-content-start">
                        <div
                          style={{ width: "200px" }}
                          className="d-flex align-items-center justify-content-start"
                        >
                          <img src={distanceIcon} alt="date" />
                          <span className="ms-2 fs-13 fw-500 cardTextGrey">
                            Estimated KM
                          </span>
                        </div>
                        <div className="fs-13 fw-500 textFontColor">
                          {viewStopDetails.est_km ?? ""}
                        </div>
                      </div>

                      <div className="mt-3 d-flex align-items-center justify-content-start">
                        <div
                          style={{ width: "200px" }}
                          className="d-flex align-items-center justify-content-start"
                        >
                          <img src={distanceIcon} alt="date" />
                          <span className="ms-2 fs-13 fw-500 cardTextGrey">
                            Actual KM
                          </span>
                        </div>
                        <div className="fs-13 fw-500 textFontColor">
                          {viewStopDetails.act_km ?? ""}
                        </div>
                      </div>

                      <div className="mt-3 d-flex align-items-center justify-content-start">
                        <div
                          style={{ width: "200px" }}
                          className="d-flex align-items-center justify-content-start"
                        >
                          <img src={timestampIcon} alt="date" />
                          <span className="ms-2 fs-13 fw-500 cardTextGrey">
                            Last tracking on
                          </span>
                        </div>
                        <div className="fs-13 fw-500 textFontColor">
                          {viewStopDetails.lasttracking ?? ""}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="h-100 col-12 col-lg-6 mt-2">
                    <div className="h-100 bg-white rounded-4 p-3 d-flex flex-column align-items-start justify-content-start">
                      <div className="fs-16 fw-600 textFontColor">
                        Vehicle details
                      </div>
                      <div className="mt-2 w-100 row d-flex align-items-stretch">
                        <div className="col-6">
                          <div
                            className="h-100 rounded-3 p-3 d-flex flex-column align-items-center justify-content-center"
                            style={{ background: "#F0F5FF" }}
                          >
                            <div
                              style={{
                                width: "64px",
                                height: "64px",
                                borderRadius: "100px",
                              }}
                            >
                              <img
                                src={
                                  viewStopDetails.vehicle_profile &&
                                  viewStopDetails.vehicle_profile.trim() !== ""
                                    ? viewStopDetails.vehicle_profile
                                    : truckIcon
                                }
                                alt="vehicle"
                                style={{ width: "64px", height: "64px" }}
                              />
                            </div>
                            <div
                              className="fs-20 fw-700"
                              style={{ color: "#28303F" }}
                            >
                              {viewStopDetails.license_plate ?? ""}
                            </div>
                            <div
                              className="fs-13 fw-500"
                              style={{ color: "#3469E7" }}
                            >
                              {viewStopDetails.vin ?? ""}
                            </div>
                          </div>
                        </div>
                        <div className="col-6">
                          <div
                            className="rounded-3 px-2 py-3"
                            style={{ border: "1px solid #EBEBEB" }}
                          >
                            <div
                              className="fs-11 fw-500"
                              style={{ color: "#626F86", textAlign: "start" }}
                            >
                              VEHICLE IDENTIFICATION NUMBER
                            </div>
                            <div
                              className="fs-14 fw-500"
                              style={{ color: "#172B4D", textAlign: "start" }}
                            >
                              {viewStopDetails.vin ?? ""}
                            </div>
                          </div>

                          <div
                            className="mt-2 rounded-3 px-2 py-3"
                            style={{ border: "1px solid #EBEBEB" }}
                          >
                            <div
                              className="fs-11 fw-500"
                              style={{ color: "#626F86", textAlign: "start" }}
                            >
                              VENDOR
                            </div>
                            <div
                              className="fs-14 fw-500"
                              style={{ color: "#172B4D", textAlign: "start" }}
                            >
                              {viewStopDetails.vendor ?? ""}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="m-2 bg-white rounded-4 p-3">
                  <div className="row">
                    <div className="col-12 ">
                      <div className="row">
                        <div className="w-100 mb-1  d-flex align-items-center justify-content-start gap-2">
                          <div
                            className={`cursor-pointer d-flex align-items-center justify-content-center rounded-3  px-2 fs-13  ${
                              selectedContactTab === "Driver"
                                ? "fw-500 active-bottom-bar "
                                : " fw-400"
                            } `}
                            style={{
                              height: "32px",
                              width: "110px",
                              color:
                                selectedContactTab === "Driver"
                                  ? "#FFFFFF"
                                  : "#172B4D",
                              background:
                                selectedContactTab === "Driver"
                                  ? "#3469E7"
                                  : "#F5F5F5",
                            }}
                            onClick={() => {
                              setSelectedContactTab("Driver");
                            }}
                          >
                            Driver
                          </div>
                          <div
                            className={`cursor-pointer d-flex align-items-center justify-content-center rounded-3  px-2 fs-13  ${
                              selectedContactTab === "coDriver"
                                ? "fw-500 active-bottom-bar "
                                : " fw-400"
                            } `}
                            style={{
                              height: "32px",
                              minWidth: "110px",
                              color:
                                selectedContactTab === "coDriver"
                                  ? "#FFFFFF"
                                  : "#172B4D",
                              background:
                                selectedContactTab === "coDriver"
                                  ? "#3469E7"
                                  : "#F5F5F5",
                            }}
                            onClick={() => {
                              setSelectedContactTab("coDriver");
                            }}
                          >
                            Co-Driver
                          </div>

                          <div
                            className={`cursor-pointer d-flex align-items-center justify-content-center rounded-3  px-2 fs-13  ${
                              selectedContactTab === "deliveryPerson"
                                ? "fw-500 active-bottom-bar "
                                : " fw-400"
                            } `}
                            style={{
                              height: "32px",
                              minWidth: "110px",
                              color:
                                selectedContactTab === "deliveryPerson"
                                  ? "#FFFFFF"
                                  : "#172B4D",
                              background:
                                selectedContactTab === "deliveryPerson"
                                  ? "#3469E7"
                                  : "#F5F5F5",
                            }}
                            onClick={() => {
                              setSelectedContactTab("deliveryPerson");
                            }}
                          >
                            Delivery Person
                          </div>
                        </div>

                        <>
                          <div style={{ overflowY: "visible" }}>
                            <div className="mt-2 sticky-table-wrapper ">
                              <table
                                className="stop-table"
                                border="1"
                                cellPadding="10"
                                style={{
                                  borderCollapse: "collapse",
                                  width: "100%",
                                  border: "1px solid #EBEBEB",
                                }}
                              >
                                <thead
                                  style={{
                                    height: "48px",
                                    /*  backgroundColor: "#F2F2F2", // ✅ Green background */
                                    color: "#8790A1", // ✅ White text
                                    fontSize: "11px", // ✅ Font size
                                    fontWeight: "400",
                                    textAlign: "left",
                                  }}
                                >
                                  <tr>
                                    <th className="ps-2">
                                      {selectedContactTab === "Driver"
                                        ? "DRIVER"
                                        : selectedContactTab === "coDriver"
                                        ? "CO-DRIVER"
                                        : "DELIVER PERSON"}
                                    </th>
                                    <th className="ps-2">MOBILE NUMBER</th>
                                    <th className="ps-2">STARTS ON</th>
                                    <th className="ps-2">ENDS ON</th>
                                    <th className="ps-2"></th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {(selectedContactTab === "Driver"
                                    ? driverList ?? []
                                    : selectedContactTab === "coDriver"
                                    ? coDriverList ?? []
                                    : selectedContactTab === "deliveryPerson"
                                    ? deliveryPersonList ?? []
                                    : []
                                  ).map((row, index1) => (
                                    <tr
                                      key={row.id}
                                      style={{
                                        height: "60px",
                                        position: "relative",
                                        overflow: "visible",
                                      }}
                                    >
                                      <td
                                        className="px-2 py-1"
                                        style={{
                                          position: "relative",
                                          overflow: "visible",
                                        }}
                                      >
                                        <div
                                          className="pe-3 py-1 fs-14 fw-400 textFontColor"
                                          style={{ width: "200px" }}
                                        >
                                          {row.driver_name ?? ""}
                                        </div>
                                      </td>
                                      <td className="px-2 py-1 fs-14 fw-400 textFontColor">
                                        {row.mobile_number ?? ""}
                                      </td>

                                      <td className="px-2 py-1 fs-14 fw-400 textFontColor">
                                        {row.start_date ?? ""}
                                      </td>
                                      <td className="px-2 py-1 fs-14 fw-400 textFontColor">
                                        {row.end_date ?? ""}
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="m-2 bg-white rounded-4 p-3">
                  <div className="row">
                    <div className="col-12 ">
                      <div className="d-flex align-items-center justify-content-center gap-2">
                        <div
                          className="col-6 col-md-4 col-lg-2 rounded-3 p-2 d-flex align-items-center justify-content-start"
                          style={{ background: "#FFFAE5" }}
                        >
                          <img src={totalAmtIc} alt="total amount" />
                          <div className="ms-2">
                            <div
                              className="fs-12 fw-400"
                              style={{ color: "#8790A1", textAlign: "start" }}
                            >
                              Total Amount
                            </div>
                            <div
                              className="fs-16 fw-600 mt-1"
                              style={{ color: "#172B4D", textAlign: "start" }}
                            >
                              {viewStopDetails.total_amount ?? "0"}
                            </div>
                          </div>
                        </div>
                        <div
                          className="col-6 col-md-4 col-lg-2 rounded-3 p-2 d-flex align-items-center justify-content-start"
                          style={{ background: "#EAFFF3" }}
                        >
                          <img src={totalKMIc} alt="totalKMIc" />
                          <div className="ms-2">
                            <div
                              className="fs-12 fw-400"
                              style={{ color: "#8790A1", textAlign: "start" }}
                            >
                              Total Kilometer
                            </div>
                            <div
                              className="fs-16 fw-600 mt-1"
                              style={{ color: "#172B4D", textAlign: "start" }}
                            >
                              {viewStopDetails.total_kilometer ?? "0"}
                            </div>
                          </div>
                        </div>

                        <div
                          className="col-6 col-md-4 col-lg-2 rounded-3 p-2 d-flex align-items-center justify-content-start"
                          style={{ background: "#F0F1FF" }}
                        >
                          <img src={totalVolumeIc} alt="totalVolumeIc" />
                          <div className="ms-2">
                            <div
                              className="fs-12 fw-400"
                              style={{ color: "#8790A1", textAlign: "start" }}
                            >
                              Total Volume
                            </div>
                            <div
                              className="fs-16 fw-600 mt-1"
                              style={{ color: "#172B4D", textAlign: "start" }}
                            >
                              {viewStopDetails.total_volume ?? "0"}
                            </div>
                          </div>
                        </div>

                        <div
                          className="col-6 col-md-4 col-lg-2 rounded-3 p-2 d-flex align-items-center justify-content-start"
                          style={{ background: "#FFEBEB" }}
                        >
                          <img src={totalPackageIc} alt="totalPackageIc" />
                          <div className="ms-2">
                            <div
                              className="fs-12 fw-400"
                              style={{ color: "#8790A1", textAlign: "start" }}
                            >
                              Total Package
                            </div>
                            <div
                              className="fs-16 fw-600 mt-1"
                              style={{ color: "#172B4D", textAlign: "start" }}
                            >
                              {viewStopDetails.total_package ?? "0"}
                            </div>
                          </div>
                        </div>
                        <div
                          className="col-6 col-md-4 col-lg-2 rounded-3 p-2 d-flex align-items-center justify-content-start"
                          style={{ background: "#F7F2FF" }}
                        >
                          <img src={totalWeightIc} alt="totalWeightIc" />
                          <div className="ms-2">
                            <div
                              className="fs-12 fw-400"
                              style={{ color: "#8790A1", textAlign: "start" }}
                            >
                              Total Weight
                            </div>
                            <div
                              className="fs-16 fw-600 mt-1 "
                              style={{ color: "#172B4D", textAlign: "start" }}
                            >
                              {viewStopDetails.total_weight ?? "0"}
                            </div>
                          </div>
                        </div>
                      </div>
                      {stopsList.map((row, index1) => (
                        <div
                          className="mt-3"
                          style={{
                            border: "1px solid #EBEBEB",
                            borderRadius: "16px",
                            backgroundColor: "#FAFAFA",
                          }}
                        >
                          {/* Stop ID */}
                          <div
                            className="px-2 py-1"
                            style={{
                              borderTopLeftRadius: "16px",
                              borderBottomRightRadius: "16px",
                              background: "#FFFFFF",
                              textAlign: "start",
                              width: "fit-content",
                              border: "1px solid #EBEBEB",
                            }}
                          >
                            <span className="fs-11 fw-400 textcolor">
                              Stop ID :{" "}
                            </span>
                            <span className="fs-12 fw-500 text-3469E7">
                              #{row.stop_code ?? ""}
                            </span>
                          </div>

                          {/* Card */}
                          <div className="d-flex justify-content-between align-items-center p-2">
                            {/* Left Section */}
                            <div className="d-flex align-items-center ">
                              {/* Image */}
                              <div
                                className="d-flex align-items-center justify-content-center"
                                style={{
                                  width: "80px",
                                  height: "80px",
                                  borderRadius: "100px",
                                  border: "0.5px solid #EBEBEB",
                                }}
                              >
                                <img
                                  src={
                                    row.profile !== ""
                                      ? row.profile
                                      : customerIcon
                                  }
                                  alt="profile"
                                  style={{ width: "40px", height: "40px" }}
                                />
                              </div>

                              <div className="ms-2 d-flex flex-column align-items-start justify-content-center">
                                <div className="fs-20 fw-600 textFontColor">
                                  {row.customer_name ?? ""}
                                </div>
                                <div className="mt-1 d-flex align-items-center justify-content-start">
                                  <img src={redPinIcon} alt="location" />{" "}
                                  <span className="ms-2 fs-13 fw-300 textFontColor">
                                    {row.to_address ?? ""}
                                  </span>
                                </div>

                                <div
                                  style={{ fontSize: "14px", marginTop: "5px" }}
                                >
                                  <span className="fs-13 fw-400 text-A2A7AE">
                                    #{row.customer_code ?? ""}
                                  </span>
                                  <span
                                    className="fs-13 fw-500"
                                    style={{
                                      marginLeft: "10px",
                                      backgroundColor: "#D6FEE6",
                                      color: "#2C8C53",
                                      padding: "2px 8px",
                                      borderRadius: "100px",
                                    }}
                                  >
                                    <span className="fs-12 fw-400 text-5F5E5B">
                                      Qty :{" "}
                                    </span>{" "}
                                    {row.quantity ?? ""}
                                  </span>
                                </div>
                              </div>
                            </div>
                            {/* Right Section */}
                            <div className="d-flex gap-2">
                              <button
                                onClick={() => {
                                  setSelectedStopIndex(
                                    selectedStopIndex === -1 ||
                                      selectedStopIndex !== index1
                                      ? index1
                                      : -1
                                  );
                                }}
                                className="btn btn-outline-primary"
                                style={{
                                  borderRadius: "100px",
                                  fontWeight: "500",
                                }}
                              >
                                <img src={productIcon} alt="productIcon" />{" "}
                                <span className="px-1 fs-12 fw-500">
                                  {" "}
                                  Products ({row.product_count ?? ""}){" "}
                                </span>
                                <img src={arrowDownIcon} alt="arrowDownIcon" />
                              </button>
                              {row.to_latitude !== null &&
                                row.to_latitude !== "" &&
                                row.to_longitude !== null &&
                                row.to_longitude !== "" && (
                                  <button
                                    onClick={() => {
                                      setMapPosition({
                                        lat: row.to_latitude,
                                        lng: row.to_longitude,
                                      });
                                    }}
                                    className="btn btn-primary"
                                    style={{
                                      borderRadius: "100px",
                                      fontWeight: "500",
                                    }}
                                  >
                                    <img
                                      src={whitePinIcon}
                                      alt="location-view"
                                    />{" "}
                                    <span className=" fs-13 fw-500">
                                      View in map
                                    </span>
                                  </button>
                                )}
                            </div>
                          </div>
                          {selectedStopIndex > -1 &&
                            selectedStopIndex === index1 && (
                              <div className="m-2 bg-white rounded-4 p-3">
                                <div className="row">
                                  <div className="col-12 ">
                                    <div className="row">
                                      <div className="col-xl-12 d-flex justify-content-between">
                                        <p className="fs-18 fw-600 mb-0">
                                          Product{" "}
                                        </p>
                                        <div
                                          className="rounded-4 d-flex justify-content-start p-2"
                                          style={{ background: "#FFF7E4" }}
                                        >
                                          <img src={dollerIc} alt="doller" />
                                          <span className="ms-2 fs-13 fw-400 cardTextGrey">
                                            Total :
                                          </span>{" "}
                                          <span className="ms-2 fs-14 fw-500 textFontColor">
                                            ₹{" "}
                                            {productList
                                              .reduce(
                                                (sum, item) =>
                                                  sum + Number(item.price),
                                                0
                                              )
                                              .toFixed(2)}
                                          </span>
                                        </div>
                                      </div>
                                      <div style={{ overflowY: "visible" }}>
                                        {isProductLoading ? (
                                          <div className="d-flex justify-content-center align-items-center py-5">
                                            <Spinner
                                              animation="border"
                                              variant="primary"
                                            />
                                          </div>
                                        ) : (
                                          <div className="mt-2 sticky-table-wrapper ">
                                            <table
                                              className="stop-table"
                                              border="1"
                                              cellPadding="10"
                                              style={{
                                                borderCollapse: "collapse",
                                                width: "100%",
                                                border: "1px solid #EBEBEB",
                                              }}
                                            >
                                              <thead
                                                style={{
                                                  height: "36px",
                                                  backgroundColor: "#F8F8F8",
                                                  color: "#8790A1",
                                                  fontSize: "11px",
                                                  fontWeight: "400",
                                                  textAlign: "left",
                                                }}
                                              >
                                                <tr>
                                                  <th className="ps-2">
                                                    PRODUCT NAME
                                                  </th>
                                                  <th className="ps-2">
                                                    WEIGHT
                                                  </th>
                                                  <th className="ps-2">
                                                    VOLUME
                                                  </th>
                                                  <th className="ps-2">UNIT</th>
                                                  <th className="ps-2">
                                                    QUANTITY
                                                  </th>
                                                  <th className="ps-2">
                                                    PRICE
                                                  </th>
                                                </tr>
                                              </thead>
                                              <tbody>
                                                {productList?.map(
                                                  (row, index) => (
                                                    <tr
                                                      key={row.id}
                                                      style={{
                                                        height: "36px",
                                                        position: "relative",
                                                        overflow: "visible",
                                                      }}
                                                    >
                                                      <td
                                                        className="px-2 py-1"
                                                        style={{
                                                          position: "relative",
                                                          overflow: "visible",
                                                        }}
                                                      >
                                                        <div className="pe-3 py-1">
                                                          {row.product}
                                                        </div>
                                                      </td>
                                                      <td className="px-2 py-1">
                                                        {row.weight}
                                                      </td>

                                                      <td className="px-2 py-1">
                                                        {row.voulme}
                                                      </td>

                                                      <td
                                                        className="px-2 py-1"
                                                        style={{
                                                          width: "150px",
                                                        }}
                                                      >
                                                        {row.unit}
                                                      </td>
                                                      <td className="px-2 py-1">
                                                        {row.quantity}
                                                      </td>
                                                      <td className="px-2 py-1">
                                                        {row.price}
                                                      </td>
                                                    </tr>
                                                  )
                                                )}
                                              </tbody>
                                            </table>
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>

                <div className="m-2 bg-white rounded-4 p-3">
                  <div className="row">
                    <div className="col-12 ">
                      <div className="row">
                        <div className="col-xl-12 d-flex justify-content-start">
                          <p className="fs-18 fw-600 mb-0">
                            Route for this stop{" "}
                          </p>
                        </div>
                      </div>

                      <div className="w-100 mt-2">
                        <MapContainer
                          center={[30, 0]}
                          zoom={2}
                          style={{ height: "355px", width: "100%" }}
                        >
                          <TileLayer
                            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
                          />

                          <MarkerClusterGroup
                            iconCreateFunction={(cluster) => {
                              const markers = cluster.getAllChildMarkers();
                              const firstMarker = markers[0];

                              return L.divIcon({
                                html: `
                                  <div style="position: relative; display: inline-block;" >
                                    <img src="${stopPinImg}"
                                          object-fit:cover;" style="
                                      width:40px;
                                      height:40px;
                                  " />
                                         <span style="
                                          position: absolute;
                                          top: 50%;
                                          left: 50%;
                                          transform: translate(-50%, -50%);
                                          color: white;
                                          font-size: 13px;
                                          font-weight: bold;
                                        ">
                                         ... ${markers.length}
                                        </span>
                                  </div>
                                `,
                                className: "custom-cluster",
                                iconSize: L.point(50, 50),
                              });
                            }}
                          >
                            {stopPinLocation.map((coord, index) => {
                              console.log(coord);
                              return (
                                <Marker
                                  key={`Stop${index}`}
                                  position={[
                                    coord.to_latitude,
                                    coord.to_longitude,
                                  ]}
                                  icon={createCustomMarker(
                                    coord.sequence || index + 1
                                  )}
                                  eventHandlers={{
                                    mouseover: (e) => {
                                      e.target.openPopup();
                                    },
                                    mouseout: (e) => {
                                      e.target.closePopup();
                                    },
                                  }}
                                >
                                  <Popup>
                                    <div
                                      style={{
                                        minWidth: "250px",
                                        padding: "10px",
                                      }}
                                    >
                                      <div className="fw-600 fs-14 mb-2">
                                        Stop #{coord.sequence || index + 1}
                                      </div>
                                      {coord.customer_name && (
                                        <div className="fs-12 mb-1">
                                          <strong>Customer:</strong>{" "}
                                          {coord.customer_name}
                                        </div>
                                      )}
                                      {coord.customer_code && (
                                        <div className="fs-12 mb-1">
                                          <strong>Code:</strong>{" "}
                                          {coord.customer_code}
                                        </div>
                                      )}
                                      <div className="fs-12 mb-1">
                                        <strong>Stop Code:</strong>{" "}
                                        {coord.stop_code}
                                      </div>
                                      <div className="fs-12 mb-1">
                                        <strong>Address:</strong>{" "}
                                        {coord.to_address}
                                      </div>
                                      {coord.product_count > 0 && (
                                        <div className="fs-12 mb-1">
                                          <strong>Products:</strong>{" "}
                                          {coord.product_count}
                                        </div>
                                      )}
                                      {coord.quantity && (
                                        <div className="fs-12 mb-1">
                                          <strong>Quantity:</strong>{" "}
                                          {coord.quantity}
                                        </div>
                                      )}
                                      <div className="fs-12">
                                        <strong>Status:</strong>{" "}
                                        <span
                                          className="badge"
                                          style={{
                                            background: "#EDF2FF",
                                            color: "#3469E7",
                                          }}
                                        >
                                          {coord.status}
                                        </span>
                                      </div>
                                    </div>
                                  </Popup>
                                </Marker>
                              );
                            })}
                          </MarkerClusterGroup>
                          {roadRouteCoords.length > 0 && (
                            <Polyline
                              positions={roadRouteCoords}
                              pathOptions={{ color: "#FDCA01", weight: 5 }}
                            />
                          )}
                        </MapContainer>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
            {selectedTab === "workflow" && (
              <div className="w-100 m-2 bg-white rounded-4 p-3">
                <div className="row">
                  <div className="col-12 ">
                    <div className="row">
                      <div className="col-xl-12 d-flex justify-content-start">
                        <p className="fs-18 fw-600 mb-0">Workflow details </p>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12 col-lg-4">
                        <div>
                          <div
                            className="mx-4 mb-3 mt-2 d-flex align-items-center justify-content-center rounded-3 px-2 py-2 fs-13 fw-600"
                            style={{ background: "#F8F8F8", color: "#5F5E5B" }}
                          >
                            ESTIMATED WORKFLOW
                          </div>
                          {estimateWorkflow.map((row, index) => (
                            <div className="w-100 d-flex justify-content-start ">
                              <div
                                className="d-flex flex-column align-items-center"
                                style={{ height: "auto" }}
                              >
                                <img src={workflowTick} alt="tick" />
                                {index !== estimateWorkflow.length - 1 && (
                                  <div
                                    style={{
                                      borderLeft: "2px dotted #aaa",
                                      height: "100%",
                                      /*  position: "absolute",
                        left: "50%",
                        top: 0, */
                                    }}
                                  ></div>
                                )}
                              </div>

                              <div className="mt-0 ms-3 mb-3">
                                <div className="d-flex align-items-center justify-content-start">
                                  <span
                                    className="fs-14 fw-700 "
                                    style={{ color: "#2C8C53" }}
                                  >
                                    {row.status}
                                  </span>
                                  {/* <div
                                    className="mx-2"
                                    style={{
                                      width: "5px",
                                      height: "5px",
                                      borderRadius: "100px",
                                      background: "#D9D9D9",
                                    }}
                                  ></div>
                                  <div
                                    className="d-flex align-items-center justify-content-center rounded-4 px-2 py-1"
                                    style={{
                                      background: "#EDF2FF",
                                      color: "#3469E7",
                                    }}
                                  >
                                    <span className="ms-2 fs-11 fw-400" style={{ color: "#5F5E5B" }}>
                                      Stop :
                                    </span>
                                    <span className="ms-2 fs-12 fw-500">
                                      #{row.stop_id}
                                    </span>
                                  </div> */}
                                </div>

                                {/* <div className="mt-2 fs-13 fw-400 textFontColor d-flex justify-content-start">
                                  Completed this stop without any issue.
                                </div> */}
                                <div className="mt-1 fs-12 fw-400 cardTextGrey d-flex justify-content-start">
                                  {row.to_char}
                                </div>
                                {/*  <div className="mt-2 d-flex align-items-center justify-content-start">
                                  <div
                                    className="d-flex align-items-center justify-content-center rounded-4 px-2 py-1 fs-11 fw-400"
                                    style={{
                                      background: "#F8F8F8",
                                      color: "#5F5E5B",
                                    }}
                                  >
                                    View attachments (8)
                                  </div>

                                  <div
                                    className="ms-2 d-flex align-items-center justify-content-center rounded-4 px-2 py-1 fs-11 fw-400"
                                    style={{
                                      background: "#F8F8F8",
                                      color: "#5F5E5B",
                                    }}
                                  >
                                    Update
                                  </div>
                                </div> */}
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>

                      <div
                        className="d-none d-lg-block mt-5"
                        style={{
                          borderLeft: "2px solid #EBEBEB",
                          height: "auto",
                          width: "auto",
                        }}
                      ></div>
                      <div className="col-12 col-lg-4">
                        <div>
                          <div
                            className="mx-4 mb-3 mt-2 d-flex align-items-center justify-content-center rounded-3 px-2 py-2 fs-13 fw-600"
                            style={{ background: "#F8F8F8", color: "#5F5E5B" }}
                          >
                            ACTUAL WORKFLOW
                          </div>
                          {actualWorkflow.map((row, index) => (
                            <div className="w-100 d-flex justify-content-start ">
                              <div
                                className="d-flex flex-column align-items-center"
                                style={{ height: "auto" }}
                              >
                                <img src={workflowTick} alt="tick" />
                                {index !== actualWorkflow.length - 1 && (
                                  <div
                                    style={{
                                      borderLeft: "2px dotted #aaa",
                                      height: "100%",
                                      /*  position: "absolute",
                        left: "50%",
                        top: 0, */
                                    }}
                                  ></div>
                                )}
                              </div>

                              <div className="mt-0 ms-3 mb-3">
                                <div className="d-flex align-items-center justify-content-start">
                                  <span
                                    className="fs-14 fw-700 "
                                    style={{ color: "#2C8C53" }}
                                  >
                                    {row.status}
                                  </span>
                                  <div
                                    className="mx-2"
                                    style={{
                                      width: "5px",
                                      height: "5px",
                                      borderRadius: "100px",
                                      background: "#D9D9D9",
                                    }}
                                  ></div>
                                  {/* <div
                                    className="d-flex align-items-center justify-content-center rounded-4 px-2 py-1"
                                    style={{
                                      background: "#EDF2FF",
                                      color: "#3469E7",
                                    }}
                                  >
                                    <span
                                      className="ms-2 fs-11 fw-400"
                                      style={{ color: "#5F5E5B" }}
                                    >
                                      Stop :
                                    </span>
                                    <span className="ms-2 fs-12 fw-500">
                                      #102910
                                    </span>
                                  </div> */}
                                </div>

                                <div className="mt-2 fs-13 fw-400 textFontColor d-flex justify-content-start">
                                  {row.comments ?? ""}
                                </div>
                                <div className="mt-1 fs-12 fw-400 cardTextGrey d-flex justify-content-start">
                                  {row.to_char ?? ""}
                                </div>
                                <div className="mt-2 d-flex align-items-center justify-content-start">
                                  <div
                                    className="d-flex align-items-center justify-content-center rounded-4 px-2 py-1 fs-11 fw-400"
                                    style={{
                                      background: "#F8F8F8",
                                      color: "#5F5E5B",

                                      cursor:
                                        (Array.isArray(row.attachments) &&
                                          row.attachments.length > 0) ||
                                        (typeof row.attachments === "string" &&
                                          row.attachments !== "")
                                          ? "pointer"
                                          : "default",
                                    }}
                                    onClick={() => {
                                      if (
                                        Array.isArray(row.attachments) &&
                                        row.attachments.length > 0
                                      ) {
                                        setAttachmentUrls(row.attachments);
                                        setShowAttachmentModal(true);
                                      } else if (
                                        typeof row.attachments === "string" &&
                                        row.attachments !== ""
                                      ) {
                                        setAttachmentUrls([row.attachments]);
                                        setShowAttachmentModal(true);
                                      }
                                    }}
                                  >
                                    View attachments (
                                    {row.attachments_count ?? "0"})
                                  </div>

                                  {row.status === "skipped" && (
                                    <div
                                      onClick={() => {
                                        setSelectedStop(row.stop_id);
                                        getSkippedMilestoneDetails(
                                          row.trip_id,
                                          row.stop_id
                                        );
                                      }}
                                      className="cursor-pointer ms-2 d-flex align-items-center justify-content-center rounded-4 px-2 py-1 fs-11 fw-400"
                                      style={{
                                        background: "#F8F8F8",
                                        color: "#5F5E5B",
                                      }}
                                    >
                                      Update
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {selectedTab === "history" && (
              <div className="w-100 m-2 bg-white rounded-4 p-3">
                <div className="row">
                  <div className="col-12 ">
                    <div className="row">
                      <div className="col-xl-12 d-flex justify-content-start">
                        <p className="fs-18 fw-600 mb-0">Allocation History </p>
                      </div>
                    </div>
                    <div className="row mt-2">
                      <div className="col-12">
                        <div>
                          {allocationHistory.map((row, index) => (
                            <div className="w-100 d-flex justify-content-start ">
                              <div
                                className="d-flex flex-column align-items-center"
                                style={{ height: "auto" }}
                              >
                                <img src={workflowTick} alt="tick" />
                                {index + 1 !== allocationHistory.length && (
                                  <div
                                    style={{
                                      borderLeft: "2px dotted #aaa",
                                      height: "100%",
                                      /*  position: "absolute",
                        left: "50%",
                        top: 0, */
                                    }}
                                  ></div>
                                )}
                              </div>

                              <div className="mt-0 ms-3 mb-3">
                                <div className="d-flex align-items-center justify-content-start">
                                  <span
                                    className="fs-14 fw-700 "
                                    style={{
                                      color:
                                        row["status"] === "Pending"
                                          ? "#ff3469E7"
                                          : row["status"] === "Accepted"
                                          ? "#ff40AE4A"
                                          : row["status"] === "Rejected"
                                          ? "#ffD72727"
                                          : "#ffD72727",
                                    }}
                                  >
                                    {row.status === "Pending"
                                      ? "Allocated"
                                      : row.status ?? "-"}
                                  </span>
                                </div>

                                {/* <div className="mt-2 fs-13 fw-400 textFontColor d-flex justify-content-start">
                                  Completed this stop without any issue.
                                </div> */}
                                <div className="mt-1 fs-13 fw-400 textFontColor d-flex justify-content-start">
                                  {row.status === "Pending"
                                    ? `Allocated to ${row.driver ?? "-"}`
                                    : row.status === "Accepted"
                                    ? ` ${
                                        row["driver"] ?? "-"
                                      } accepted allocation request !`
                                    : row.status === "Rejected"
                                    ? `${row["comment"]}`
                                    : ` ${row["driver"] ?? "-"}`}
                                </div>
                                <div className="mt-1 fs-12 fw-400 cardTextGrey d-flex justify-content-start">
                                  {row.date ?? ""}
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
        <Modal
          show={showMap}
          onHide={() => setShowMap(false)}
          size="lg"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>Stop Location</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div style={{ height: "400px", width: "100%" }}>
              <MapContainer
                center={[20.5937, 78.9629]}
                zoom={5}
                style={{ height: "100%", width: "100%" }}
              >
                <TileLayer
                  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                  attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
                />

                {mapPosition && <Marker position={mapPosition} />}
              </MapContainer>
            </div>
            <div className="mt-2 text-muted fs-13">
              {mapPosition
                ? `Selected: ${mapPosition.lat}, ${mapPosition.lng}`
                : "Click on the map to select a location"}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="light" onClick={() => setShowMap(false)}>
              Cancel
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
      <Modal
        show={showAttachmentModal}
        onHide={() => setShowAttachmentModal(false)}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Attachment</Modal.Title>
        </Modal.Header>
        <Modal.Body className="d-flex justify-content-center align-items-center bg-light p-0">
          {attachmentUrls.length > 0 ? (
            <Carousel
              interval={null}
              className="w-100"
              style={{ background: "#333" }}
            >
              {attachmentUrls.map((url, index) => (
                <Carousel.Item key={index} className="text-center">
                  <div
                    className="d-flex justify-content-center align-items-center"
                    style={{ height: "80vh" }}
                  >
                    <img
                      src={url}
                      alt={`Attachment ${index + 1}`}
                      style={{
                        maxWidth: "100%",
                        maxHeight: "100%",
                        objectFit: "contain",
                      }}
                    />
                  </div>
                </Carousel.Item>
              ))}
            </Carousel>
          ) : attachmentUrl ? (
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ height: "80vh", width: "100%" }}
            >
              <img
                src={attachmentUrl}
                alt="Attachment"
                style={{
                  maxWidth: "100%",
                  maxHeight: "100%",
                  objectFit: "contain",
                }}
              />
            </div>
          ) : null}
        </Modal.Body>
      </Modal>
      <ToastContainer position="top-end">
        <Toast
          className="d-inline-block m-1"
          bg={snackbarStatus === true ? "success" : "danger"}
          show={showSnackbar}
          onClose={handleSnackbarClose}
          delay={3000}
          autohide
        >
          <Toast.Body style={{ color: "#ffffff" }}>
            {snackbarMessage}
          </Toast.Body>
        </Toast>
      </ToastContainer>
    </>
  );
};
